import { ContextStore, PageStore } from 'bernie-plugin-mobx';

import { codeSplit, Controller, FetchOptions } from 'bernie-core';
import { PageData } from 'bernie-http';

import { meta } from 'utils/meta';

export class HotelHomeController implements Controller {
  public bundles = ['hotel-home'];
  public component = codeSplit(() => import(/* webpackChunkName: "hotel-home" */ 'views/hotel/home.tsx'));
  public pageId = 'page.Hotels,H,10';
  public path = '/(Hotels|Hotel|overseas-hotel|domestic|Hoteles|Hoteis|hotels-HK|Hoteller|Hotellit|Hotell)';
  public exact = false;
  public routeName = 'hotel-home';
  public routeData = {
    rfrrNamespace: 'HP.RB.HOTEL',
    pageName: 'page.Hotels',
  };

  public fetch(options: FetchOptions): Promise<any> {
    const { stores } = options;
    const context = stores && stores.get<ContextStore>('context');
    const page = stores && stores.get<PageStore>('page');

    return Promise.resolve().then(() => page.fetch(meta['hotel-home'], context.site, context.locale));
  }

  public fetchPageData(): Promise<PageData> {
    return Promise.resolve(null as PageData);
  }
}
